export default __webpack_public_path__ + "d5f905e098b32bfd98d2514f696b35c8.png";